// extracted by mini-css-extract-plugin
module.exports = {"matrixElement":"style_matrixElement__2Vm29","flexRow":"style_flexRow__5dur0"};